import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import foodbrand from '../../assets/foodbrand@2x.png';
import Pantalla26 from '../Pantalla26/Pantalla26';
import Header from '../../Header/Header';

function PantallaBase26({ }) {

    const location = useLocation();
    const navigate = useNavigate();

    const onComplete = async () => {
        navigate('/PantallaBase27');
    }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header
                    imgBack={false}
                    rutaBack='/PantallaBase22'
                    title='Identificación Personal'
                    name='steepFour'
                />

                <div className='containerRender'>

                    <Pantalla26 />

                    <div className="footer">
                        <div className='containerCont_P2'>
                            <button className='button_P2' onClick={onComplete} >
                                <span className='txtButton_P2'>Completar</span>
                            </button>
                        </div>
                        <div className='imageContainer_P2'>
                            <img src={foodbrand} className='imgFooter_P2' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PantallaBase26
